// extracted by mini-css-extract-plugin
export default {"list":"dl4pj","item":"d3Ovb"};